import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedPlants from './components/FeaturedPlants';
import HowToGuides from './components/HowToGuides';
import PlacementGuide from './components/PlacementGuide';
import TechnicalInfo from './components/TechnicalInfo';
import Testimonials from './components/Testimonials';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <FeaturedPlants />
      <HowToGuides />
      <PlacementGuide />
      <TechnicalInfo />
      <Testimonials />
      <Newsletter />
      <Footer />
    </div>
  );
}

export default App;
